<script setup>
import IHeader from "@/Layouts/Parts/IHeader.vue"
import IFooter from "@/Layouts/Parts/IFooter.vue"
import GlobalNotifications from "@/Components/GlobalNotifications.vue"
import LSubHeader from "@/Layouts/Parts/LSubHeader.vue"
import LNewSubHeader from "@/Layouts/Parts/LNewSubHeader.vue";

defineProps({
    cart: {
        type: Boolean,
        default: true
    },
    bgColor: {
        type: String,
        default: "bg-white"
    },
    switchCategoryMenu: {
        type: Boolean,
        default: false
    }
})

</script>

<template>
    <v-app>
        <i-header :cart="cart"/>
        <l-new-sub-header v-if="switchCategoryMenu"></l-new-sub-header>
        <l-sub-header v-else></l-sub-header>
        <v-main style="--v-layout-top: 0px" :class="{[bgColor]: true}">
            <slot/>
        </v-main>
        <i-footer/>

        <GlobalNotifications/>
    </v-app>
</template>